// src/pages/Map.js
import React from "react";
import MapWidget from "../components/MapWidget";

export default function Map() {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(50vh - 0px)", // adjust height to match your navbar
        marginTop: "0px",            // same number as navbar height
      }}
    >
      <MapWidget />
    </div>
  );
}